import styles from './FeedRowShimmer.module.scss'
import {
  Stack,
  Skeleton
} from '@mui/material'

function FeedRowShimmer ({ count = 1 }: { count: number }) {
  const array = Array.from({ length: count }, (_, i) => i)
  return (
    <>
      <div className={styles.shimmerWrapper}>
        {array.map((n) => {
          return (
            <div key={n} className={styles.shimmerRow}>
              <div className={styles.shimmer}>
                <div className={styles.left}>
                  <Stack spacing={1}>
                    <Skeleton variant="text" sx={{ height: 50 }} />
                    <Skeleton variant="text" sx={{ width: '90%' }} />
                    <Skeleton variant="text" sx={{ width: '80%' }} />
                  </Stack>
                </div>
                <div className={styles.right}>
                  <Skeleton variant="rectangular" sx={{ height: 125, width: 180 }} />
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </>
  )
}

export default FeedRowShimmer
